import type { ComponentPropsWithoutRef, ReactNode } from "react";
import classNames from "classnames";

export interface DropdownWrapperProps extends ComponentPropsWithoutRef<"div"> {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
}

export const DropdownWrapper = ({
  children,
  className,
  dataTestId,
  ...rest
}: DropdownWrapperProps) => (
  <div
    className={classNames("flex flex-row items-center space-x-px", className)}
    data-testid={dataTestId}
    {...rest}
  >
    {children}
  </div>
);
